// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"ff0b305b","327":"611befa3"}[chunkId] + ".chunk.js";
};